<div class="modal-header">
  <h5 class="modal-title" *ngIf="isAdd">Добавление движимого объекта</h5>
  <h5 class="modal-title" *ngIf="!isAdd">Редактирование движимого объекта</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window">

  <div class="form form-horizontal">

    <div class="form-body">

      <!-- Name -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Вид, наименование <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field>
            <mat-select required [(ngModel)]="object.name">
              <mat-option *ngFor="let option of nameObjects" [value]="option.name">
                {{option.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Kind -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Вид собственности <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field>
            <mat-select required [(ngModel)]="object.type">
              <mat-option *ngFor="let option of typeObjects" [value]="option.name">
                {{option.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </div>

  </div>

</div>

<div class="modal-footer" style="justify-content: center">
  <button class="btn btn-raised btn-warning" mat-dialog-close>Отмена</button>
  <button class="btn btn-raised btn-info" (click)=save()>Сохранить</button>
</div>

